import { render, staticRenderFns } from "./TBA_feedback.vue?vue&type=template&id=0c66333e&"
import script from "./TBA_feedback.vue?vue&type=script&lang=js&"
export * from "./TBA_feedback.vue?vue&type=script&lang=js&"
import style0 from "./TBA_feedback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports